import React, { useEffect, useMemo } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCIcon, RCCInput, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import LovUsers from "src/components/Lov/Users";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { IParticipantsAudit } from "../../interface";
import { IComponentAuditorsAndParticipants } from "./interface";

const Participants: React.FC<IComponentAuditorsAndParticipants> = ({
	data,
	control,
	error,
	participants,
	register,
	clearErrors,
	disabled
}) => {
	const { translate } = useTranslation();
	
	const { 
		fields: fieldsItem, 
		remove: removeItem,
		append: appendItem
	} = useFieldArray({
		control,
		name: "adtbb003",
		shouldUnregister: true
	});

	const addNewItem = (type: "u" | "f") => {
		clearErrors("adtbb003");
        
		const newItem = {
			id: v4(),
			adb003Id: 0,
			adb003Efa005Id: type === "u" ? 0 : undefined,
			adb003Efa005Nome: "",
			adb003Nomeparticipante: "",
			type
		};

		appendItem(newItem);
	};

	const handleRemoveItem = (index: number) => {	
		clearErrors("adtbb003");		
		removeItem(index);
	};

	useEffect(() => {
		if(data){
			appendItem(data?.map((item: IParticipantsAudit) => ({
				...item,
				id: v4(),
				type: item.adb003Efa005Id ? "u" : "f"
			})));
		}
	}, []);

	const ListParticipantsMemo = useMemo(() => (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
				justifyContent="center"
			>
				{fieldsItem.filter((consult: any) => consult.type === "u").length > 0 && (
					<RCCGrid
						container
						item
						xs={12}
						md={10}
					>
						<Title color="purple"
							size="sm"
						>
							{translate("Participantes")}
						</Title>
						<hr />
					</RCCGrid>
				)}
				<RCCGrid
					container
					item
					xs={12}
					md={10}
				>
					{fieldsItem.map((consult: any, index) => consult.type === "u"  && (
						<RCCGrid
							key={v4()}
							container
							item
							alignItems="flex-end"
							justifyContent="space-between"
						>
							<input 
								name={`${participants.nameOfObject}[${index}].${participants.nameOfID}`} 
								type="text"
								value={consult.adb003Id || 0}
								{...register(`${participants.nameOfObject}[${index}].${participants.nameOfID}`)} 
								style={{ display: "none" }} 
								readOnly
							/>

							<input 
								name={`${participants.nameOfObject}[${index}].type`} 
								type="text"
								value={consult.type}
								{...register(`${participants.nameOfObject}[${index}].type`)} 
								style={{ display: "none" }} 
								readOnly
							/>

							<RCCGrid
								container
								item
								xs={11}
							>
								<LovUsers 
									control={control}
									label=""
									name={`${participants.nameOfObject}[${index}].${participants.nameOfSelectUser}`}
									defaultValue={consult.adb003Efa005Id && (consult.adb003Efa005Nome ? { value: String(consult.adb003Efa005Id), label: consult.adb003Efa005Nome } : consult.adb003Efa005Id.toString())}
									error={error.adtbb003 && error.adtbb003[index]?.adb003Efa005Id}
									disabled={disabled}
									onChangeCapture={() => clearErrors("adtbb003")}
									styleInline="height: 40px; min-height: 40px;"
								/>
							</RCCGrid>
							<RCCTooltip
								color="red"
								text={translate("Remover")}
							>
								<RCCButton 
									color="red"
									icon={{
										name: "trash"
									}}
									onClick={() => handleRemoveItem(index)}
									disabled={disabled}
								/>
							</RCCTooltip>
						</RCCGrid>
					))}
				</RCCGrid>
			</RCCGrid>
			{/* Livres */}
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
				justifyContent="center"
			>
				{fieldsItem.filter((consult: any) => consult.type === "f").length > 0 && (
					<RCCGrid
						container
						item
						xs={12}
						md={10}
					>
						<Title color="purple"
							size="sm"
						>
							{translate("Participante Externo")}
						</Title>
						<hr />
					</RCCGrid>
				)}
				<RCCGrid
					container
					item
					xs={12}
					md={10}
				>
					{fieldsItem.map((consult: any, index) => consult.type === "f" && (
						<RCCGrid
							key={v4()}
							container
							item
							alignItems="flex-end"
							justifyContent="space-between"
						>
							<input 
								name={`${participants.nameOfObject}[${index}].${participants.nameOfID}`} 
								type="text"
								value={consult.adb003Id || 0}
								{...register(`${participants.nameOfObject}[${index}].${participants.nameOfID}`)} 
								style={{ display: "none" }} 
								readOnly
							/>

							<input 
								name={`${participants.nameOfObject}[${index}].type`} 
								type="text"
								value={consult.type}
								{...register(`${participants.nameOfObject}[${index}].type`)} 
								style={{ display: "none" }} 
								readOnly
							/>

							<RCCGrid
								container
								item
								xs={11}
							>
								<RCCInput 
									register={register}
									name={`${participants.nameOfObject}[${index}].${participants.nameOfFreeName}`} 
									label={translate("Nome")}
									defaultValue={consult.adb003Nomeparticipante}
									maxLength={200}
									onBlurCapture={() => clearErrors("adtbb003")}
									error={error.adtbb003 && error.adtbb003[index]?.adb003Nomeparticipante}
									required
								/>
							</RCCGrid>
							<RCCTooltip
								color="red"
								text={translate("Remover")}
							>
								<RCCButton 
									color="red"
									icon={{
										name: "trash"
									}}
									onClick={() => handleRemoveItem(index)}
									disabled={disabled}
								/>
							</RCCTooltip>
						</RCCGrid>
					))}
				</RCCGrid>
			</RCCGrid>
		</>
	),[fieldsItem]);

	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
		>
			{/* User */}
			<RCCGrid
				container
				item
				direction="column"
			>            
				<RCCGrid 
					container
					item
				>
					<RCCGrid
						container
						item
						xs={6}
						alignContent="center"
					>
						<RCCTooltip
							color="purple"
							text={translate("Adicionar usuário")}
						>
							<RCCButton
								color="purple"
								icon={{
									name: "plus"
								}}
								onClick={() => addNewItem("u")}
								disabled={disabled}
							>
								{translate("Usuário")}
							</RCCButton>
						</RCCTooltip>
						<RCCTooltip
							color="grey"
							text={translate("Participante Externo")}
						>
							<RCCButton
								color="grey"
								icon={{
									name: "plus"
								}}
								onClick={() => addNewItem("f")}
								disabled={disabled}
							>
								{translate("Participante Externo")}
							</RCCButton>
						</RCCTooltip>
					</RCCGrid>
					<RCCGrid
						container
						item
						xs={6}
						alignContent="center"
						alignItems="center"
						justifyContent="flex-end"
					>
						{error[participants.nameOfObject] && (
							<>
								<RCCIcon name="infoCircle" size={18} color="var(--red)"/>
								<Title color="red" size="xs">{error[participants.nameOfObject].message}</Title>
							</>
						)}
					</RCCGrid>
				</RCCGrid>
				{
					fieldsItem.length === 0 &&
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("Nenhum item encontrado")}
					/>
				}
				
				{ListParticipantsMemo}
			</RCCGrid>
		</RCCGrid>
	);
};

export default Participants;
